import { common as ukCommon } from "./uk/common";
import { common as roCommon } from "./ro/common";
import { common as ruCommon } from "./ru/common";

export const common = {
  uk: ukCommon,
  ro: roCommon,
  ru: ruCommon,
};
